import { IncidentQueryResult } from '@/graphql/generated/hooks'
import { IncidentQuery } from '@/graphql/generated/operations'
import { ResolutionSegment } from '@/graphql/generated/schemas'

export type IncidentNotesMediaType =
  IncidentQueryResult['data']['incident']['notes']['edges']['0']['node']['media']['0']

export interface IncidentNoteMediaIProps {
  files: IncidentNotesMediaType[]
}

export interface RenderMediaFileIProps {
  file: IncidentNotesMediaType
  onFileClick: (file: IncidentNotesMediaType) => void
}

export enum NonActionItem {
  IncidentNote = 'IncidentNote',
  AudioMessage = 'AudioMessage',
  SystemAction = 'SystemAction',
}

export enum CannedIncidentActionType {
  Email = 'EMAIL',
}

// Extended action types not yet in the generated schema
export enum ExtendedIncidentActionType {
  PriorityChange = 'PRIORITY_CHANGE',
}

export type PriorityChangeHistory = {
  incidentActionType: string
  oldValue: string | null
  newValue: string
}

export type CannedEmailIncidentAction = {
  id: string
  createdAt: string
  creator?: IncidentCreatorType
  type: CannedIncidentActionType
  __typename?: CannedIncidentActionType.Email
}

export interface SegmentWithTextI {
  segment: ResolutionSegment
  text: string
}

export type IncidentActionType =
  IncidentQueryResult['data']['incident']['actions']['0']

export type IncidentCreatorType =
  IncidentQueryResult['data']['incident']['creator']

export type IncidentEventType =
  IncidentQueryResult['data']['incident']['events']

export type IncidentAudioMessageType =
  IncidentQueryResult['data']['incident']['audioMessages']['edges']['0']['node']

export type IncidentNoteType =
  IncidentQueryResult['data']['incident']['notes']['edges']['0']['node']

export enum TimelineOrder {
  Asc = 'Asc',
  Desc = 'Desc',
}

export type QuickReportDetailT = IncidentQuery['incident']['externalDetail']

export type QuickReportDetailsT =
  IncidentQuery['incident']['quickReportDetails']

export type QuickReportDisplayAnswerT = NonNullable<
  IncidentQuery['incident']['quickReportDetails']
>['displayAnswers'][number]
